export default __webpack_public_path__ + "static/media/people-carrying-shopping-bags-collection_52683-15820.81320a60.jpg";